export const confirmAction = (fn, title = 'هل انت متأكد؟') => {
	// eslint-disable-next-line no-restricted-globals
	if (confirm(title)) {
		fn();
	}
};
